import React, { useEffect, useState } from 'react';
import { Button, Col, Drawer, Popconfirm, Row, Space, Table, Typography, Card, Tooltip } from 'antd';
import { openNotification } from '../../../utils';
import TrashIcon from 'assets/icons/trash.svg';
import PenIcon from 'assets/icons/pen.svg';
import dayjs from 'dayjs';
import { APP_DATE_FORMAT } from 'config/constants';
import { listLeaves, deleteLeave } from '../services/leaveService';
import LeaveForm from './Form';

export default function LeaveList({ referenceId }: { referenceId?: number }){
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [open, setOpen] = useState(false);
  const [editingId, setEditingId] = useState<number | undefined>();
  
  const typeMap: Record<string, string> = {"ANNUAL_PAID":"Yıllık Ücretli İzin","SICK_WITH_REPORT":"Raporlu Hastalık İzni","UNPAID":"Ücretsiz İzin","EXCUSE":"Mazeret İzni","MARRIAGE":"Evlilik İzni","MATERNITY":"Doğum İzni","NURSING":"Süt İzni","PATERNITY":"Babalık İzni","ADOPTION":"Evlat Edinme İzni","BEREAVEMENT":"Ölüm (Vefat) İzni","JOB_SEARCH":"Yeni İş Arama İzni"};
  const fetchData = async () => {
    const res = await listLeaves(page-1, pageSize, 'startDate,desc', referenceId !== undefined ? 'accountId.equals=' + referenceId : '');
    setData(res.content);
    setTotal(res.totalElements);
  };
  useEffect(() => { if(referenceId !== undefined) fetchData(); }, [page, pageSize, referenceId]);
  const openCreate = () => { setEditingId(undefined); setOpen(true); };
  const openEdit = (id:number) => { setEditingId(id); setOpen(true); };
  const handleClose = () => setOpen(false);
  const handleDelete = async (id:number) => {
    try {
      await deleteLeave(id);
      openNotification('success', 'Başarılı', 'P.K.M İzin Silindi');
      fetchData();
    } catch (e) {
      openNotification('error', 'Hata', 'P.K.M İzin silme işlemi başarısız');
    }
  };
  const columns = [
    { title: 'İzin Türü', dataIndex: 'type', sorter: true, render: (v: any) => typeMap[v] ?? v },
    { title: 'Başlangıç Tarihi', dataIndex: 'startDate', sorter: true, render: (v: string) => v ? dayjs(v).format(APP_DATE_FORMAT) : '' },
    { title: 'Bitiş Tarihi', dataIndex: 'endDate', sorter: true, render: (v: string) => v ? dayjs(v).format(APP_DATE_FORMAT) : '' },
    { title: 'Not', dataIndex: 'note' },
    { title: 'İşlemler', render: (_:any, r:any) => (
      <Space>
        <Tooltip title='Düzenle'>
          <Button
            icon={<img src={PenIcon} alt="pen" className="icon" />}
            shape="circle"
            onClick={() => openEdit(r.id)}
            className="icon-button"
          />
        </Tooltip>
        <Popconfirm title='Sil?' onConfirm={() => handleDelete(r.id)}>
          <Tooltip title='Sil'>
            <Button
              icon={<img src={TrashIcon} alt="trash" className="icon" />}
              shape="circle"
              className="icon-button ml-12px"
            />
          </Tooltip>
        </Popconfirm>
      </Space>
    ) }
  ];
  return (
    <>
      
      <Card
        className='br-30px kontrolx-card'
        title={<Typography.Title level={4} style={{ margin: 0 }}>İzin Bilgileri</Typography.Title>}
        extra={<Button type='primary' onClick={openCreate}>İzin Ekle</Button>}
      >
        <Table rowKey='id' dataSource={data} columns={columns} pagination={{ current: page, pageSize, total, onChange:(p,s)=>{setPage(p); setPageSize(s);} }} />
      </Card>
      <Drawer open={open} onClose={handleClose} destroyOnClose width={480} title={editingId ? 'İzin Düzenle' : 'İzin Ekle'}>
        <LeaveForm id={editingId} onSuccess={() => { handleClose(); fetchData();}} referenceId={referenceId} />
      </Drawer>
    </>
  );
}
